import { IGlInsertType } from "../types/loan-eligibility-types.types";
import { API_PATHS } from "../constants/api-paths";
import { encryptedRequest } from "../core/api.client";

// Mock Implementation
export const glInsertAPI = async (data: IGlInsertType) => {
  const response = await encryptedRequest<IGlInsertType>({
    method: "POST",
    url: API_PATHS.glInsertAPi,
    data,
  });

  return response;
};
